import sessionDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/sessionDataEntry';
import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';
import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';

const navigations = [sessionDataEntry, outcomesDataEntry, courseWrapper];

export default navigations;
